import {
  Body,
  Group,
  MaterialIcon,
  Stack,
  useWindowProperties,
} from '@qred/components-library';
import React from 'react';
import useTranslate from '~/hooks/useTranslate';

export const UniqueSellingPoints = () => {
  const t = useTranslate();
  const { isMobile } = useWindowProperties();

  return (
    <Stack spacing={12}>
      <Group spacing={'sm'} nowrap>
        <MaterialIcon
          src="star"
          bg={isMobile ? 'Container/Option_6_(Light_Green)' : undefined}
          style={{
            borderRadius: '50%',
          }}
        />
        <Body size="lg" data-record>
          {t(
            'UpdateApplication.CheckpointBoostedApplicationStepDescriptionUSP1'
          )}
        </Body>
      </Group>
      <Group spacing={'sm'} nowrap>
        <MaterialIcon
          src="speed"
          bg={isMobile ? 'Container/Option_6_(Light_Green)' : undefined}
          style={{
            borderRadius: '50%',
          }}
        />
        <Body size="lg" data-record>
          {t(
            'UpdateApplication.CheckpointBoostedApplicationStepDescriptionUSP2'
          )}
        </Body>
      </Group>
      <Group spacing={'sm'} nowrap>
        <MaterialIcon
          src="rocket_launch"
          bg={isMobile ? 'Container/Option_6_(Light_Green)' : undefined}
          style={{
            borderRadius: '50%',
          }}
        />
        <Body size="lg" data-record>
          {t(
            'UpdateApplication.CheckpointBoostedApplicationStepDescriptionUSP3'
          )}
        </Body>
      </Group>
    </Stack>
  );
};
